import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-individual-dashboard',
  templateUrl: './individual-dashboard.component.html',
  styleUrls: ['./individual-dashboard.component.css']
})
export class IndividualDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
